/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Tapaa ihmisiä, keskustele, pidä hauskaa",
      "Virheellinen puhelinnumero",
      "Get the app",
      "Jatka Applella",
      "Jatka Facebookilla",
      "Jatka Googlella",
      "Kirjaudu sisään",
      "Rekisteröidy",
      "Jatka kirjoittamalla näkemäsi merkit syöttökenttään.",
      "Jatka",
      "Syötä näkemäsi teksti",
      "Turvatarkastus",
      "Lataa uudelleen",
      "﻿﻿Luo uusi salasana, jonka muistat helposti:",
      "Päivitä",
      "Vahvista salasana",
      "Salasanan minimipituus on {{num}} [[characters:num]]",
      "Salasana",
      "Luo uusi salasana",
      "Badoo - The Blog",
      "Työt",
      "Chattaa",
      "Kaupunkeja",
      "Hallinnoi evästeitä",
      "Copyright © 2006 – tähän päivään. Bumble. Kaikki oikeudet pidätetään.",
      "Apple ja Apple-logo ovat Apple Inc:n tavaramerkkejä.{{__EOL__}}Google Play on Google LLC:n tavaramerkki.",
      "Lataa",
      "Facebook",
      "Seuraa meitä",
      "Asiakastuki",
      "Instagram",
      "Kieli",
      "LinkedIn",
      "Yleistä",
      "Badoo-palvelun tarjoaa Bumble Inc.",
      "Tietosuoja",
      "Turvallisuuskeskus",
      "Sivustokartta",
      "Lausunto nykyajan orjuudesta",
      "Käyttöehdot",
      "Twitter",
      "Syötä sähköpostisi tai puhelinnumerosi alla olevaan kenttään. Lähetämme sinulle ohjeet uuden salasanan luomiseen.",
      "Luo uusi salasana",
      "Kirjoita sähköpostisi tai puhelinnumerosi",
      "Unohtunut salasana",
      "Kuvissa esiintyvät ihmiset ovat vain esimerkkejä",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Ei tarvetta synkkaukseen.{{__EOL__}}{{__EOL__}}Sukella suoraan keskusteluun ja käy asiaan. Niinhän ihmiset tutustuvat toisiinsa.",
      "Valmis keskustelemaan?",
      "Rekisteröitymällä sitoudut noudattamaan <a class=\"link\" href=\"{{terms_url}}\">käyttöehtojamme</a>. Tietoa datan käytöstä löytyy <a class=\"link\" href=\"{{privacy_url}}\">tietosuojakäytännöstämme</a>",
      "Meillä deittailet omana itsenäsi, <br />sujuvasti.",
      "Deittaile varmuudella.",
      "Tai",
      "Onko sinulla tili?",
      "Rekisteröidy sähköpostilla tai puhelinnumerolla",
      "Löydä juuri sitä mitä haet.{{__EOL__}}Anteeksipyytelemättä.",
      "Haetko vain juttuseuraa? Sehän sopii.{{__EOL__}}Onko sitoutuminen mielessä? Loistohomma.{{__EOL__}}{{__EOL__}}Jos mielesi muuttuu, niin sekin käy.",
      "Deittailemassa",
      "Valmis parisuhteeseen",
      "Avoin keskusteluille",
      "Tapaa samanhenkisiä tyyppejä.",
      "{{name}}, {{age}}",
      "Turvallisuutesi on etusijalla.",
      "Vieraile turvallisuuskeskuksessamme löytääksesi kaiken tarvitsemasi tuen.",
      "Vieraile turvallisuuskeskuksessamme.",
      "Turvallisuus ensin,<br/>toiseksi ja aina.",
      "Eka hetkestä asti tiesin, että tämä toimisi…",
      "Alussa en etsinyt mitään vakavaa…",
      "Paras vinkki kaikille Badoo-sovelluksessa on olla oma itsensä…",
      "Tutustu Badoo-yhteisöömme",
      "Lue lisää kertomuksia",
      "{{num}}__CUT__Arvostelu",
      "Apple App Store",
      "Luota meihin. Olemme tuoneet miljoonia (ja miljoonia ja miljoonia) ihmisiä yhteen jo vuodesta 2006.",
      "{{num}}M+__CUT__Latausta",
      "{{num}}Milj.+",
      "Google Play Store",
      "Osaamme asiamme.",
      "Kirjaudu sähköpostilla tai puhelinnumerolla",
      "Syötä salasanasi",
      "Unohditko salasanasi?",
      "Rekisteröidy",
      "Ei tiliä?",
      "Kirjaudu sisään",
      "Rekisteröidy"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta",
                  "kirjainta"
            ],
            "singular": [
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain",
                  "kirjain"
            ]
      },
      "day": {
            "plural": [
                  "päivää",
                  "päivää",
                  "päivän",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää"
            ],
            "singular": [
                  "päivä",
                  "päivä",
                  "päivän",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä"
            ]
      },
      "hour": {
            "plural": [
                  "tuntia",
                  "tuntia",
                  "tunnin",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia"
            ],
            "singular": [
                  "tunti",
                  "tunti",
                  "tunnin",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti"
            ]
      },
      "minute": {
            "plural": [
                  "minuuttia",
                  "minuuttia",
                  "minuutin",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia"
            ],
            "singular": [
                  "minuutti",
                  "minuutti",
                  "minuutin",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti"
            ]
      },
      "month": {
            "plural": [
                  "kuukautta",
                  "kuukautta",
                  "kuukauden",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta"
            ],
            "singular": [
                  "kuukausi",
                  "kuukausi",
                  "kuukauden",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi"
            ]
      },
      "second": {
            "plural": [
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia"
            ],
            "singular": [
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti"
            ]
      },
      "year": {
            "plural": [
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta"
            ],
            "singular": [
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
